function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 20.7999C18.5673 20.7999 20 19.3672 20 17.5999C20 15.8326 18.5673 14.3999 16.8 14.3999C15.0327 14.3999 13.6 15.8326 13.6 17.5999C13.6 19.3672 15.0327 20.7999 16.8 20.7999Z",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4 20C27.7255 20 28.8 18.9254 28.8 17.6C28.8 16.2745 27.7255 15.2 26.4 15.2C25.0745 15.2 24 16.2745 24 17.6C24 18.9254 25.0745 20 26.4 20Z",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.59998 25.6C11.6964 24.0396 14.2155 23.2 16.8 23.2C19.3845 23.2 21.9035 24.0396 24 25.6",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 23.1999C23.5647 22.6798 24.9642 22.3999 26.4 22.3999C27.8359 22.3999 29.2353 22.6798 30.4 23.1999",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var SvgCustomersTablet = function SvgCustomersTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomersTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customers-tablet.9d3f44dc.svg";
export { ForwardRef as ReactComponent };